import request from '@utils/request'

export function fetchEndpoints(params) {
  return request({
    url: '/admin/endpoint',
    method: 'get',
    params,
  })
}
